import { render, staticRenderFns } from "./BrokenHeartIcon.vue?vue&type=template&id=56040d4e&"
import script from "./BrokenHeartIcon.vue?vue&type=script&lang=js&"
export * from "./BrokenHeartIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports